import {ResponseStatus} from "../../actions/types";
import {CurrentUserSliceData} from "../slices/current-user.slice";

export function handleGetCurrentUser(state: CurrentUserSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.currentUser = payload && payload.currentUser;
            break;
    }
}